export function preventOnlyFloat(event) {
  event = event ? event : window.event;
  let charCode = event.which ? event.which : event.keyCode;

  if (charCode === 45 || charCode === 46 || (charCode >= 48 && charCode <= 57))
    return true;

  return event.preventDefault();
}

export function preventOnlyNumber(event) {
  event = event ? event : window.event;
  let charCode = event.which ? event.which : event.keyCode;

  if (charCode < 48 || charCode > 57) return event.preventDefault();
  else true;
}

export function preventBlockNumber(event) {
  event = event ? event : window.event;
  let charCode = event.which ? event.which : event.keyCode;

  if (charCode < 48 || charCode > 57) return true;
  else event.preventDefault();
}
